module.exports = __webpack_public_path__ + "static/media/view certificate.53d33cb9.svg";